<template>
    <v-col cols="12" md="6" sm="12" xs="12">
        <v-text-field
            type="number"
            density="compact"
            variant="outlined"
            v-model="form.copier.num_mails_per_month"
            label="How many pieces of mail are you sending per month?">
        </v-text-field>
    </v-col>
</template>

<script setup lang="ts">
import { storeToRefs } from 'pinia'
import { useGlobalsStore } from '@/stores/globals'

const store = useGlobalsStore()
const { form } = storeToRefs(store)
</script>
